<template>
  <div v-if="loading" class="spinner-container">
    <div class="spinner"></div>
  </div>
  
  <div v-else class="app-container">
    <!-- Header -->
    <header class="app-header">
      <div class="header-content">
        <div class="back-button" @click="goBack()">
          <i class="bi bi-arrow-left"></i>
        </div>
        <div class="header-title">
          <h2>{{ language?.add_staff || 'Staff Management' }}</h2>
        </div>
        <div class="header-action">
          <button class="btn-add" data-bs-toggle="offcanvas" data-bs-target="#branch" @click="add_new_staff()">
            <i class="bi bi-plus"></i>
          </button>
        </div>
      </div>
    </header>

    <!-- Main Content -->
    <main class="main-content">
      <!-- CSV Upload Section -->
      <!--<div class="csv-section">-->
      <!--  <div class="section-header">-->
      <!--    <h3>Bulk Import</h3>-->
      <!--  </div>-->
      <!--  <div class="csv-card">-->
      <!--    <div class="csv-content">-->
      <!--      <div class="csv-icon">-->
      <!--        <i class="bi bi-file-earmark-spreadsheet"></i>-->
      <!--      </div>-->
      <!--      <div class="csv-info">-->
      <!--        <h4>Upload CSV File</h4>-->
      <!--        <p>Import multiple staff members at once</p>-->
      <!--      </div>-->
      <!--    </div>-->
      <!--    <div class="csv-action">-->
      <!--      <label for="csv-upload" class="btn-csv">-->
      <!--        <i class="bi bi-cloud-upload"></i>-->
      <!--        Upload CSV-->
      <!--      </label>-->
      <!--      <input -->
      <!--        id="csv-upload" -->
      <!--        type="file" -->
      <!--        @change="handleFileUpload" -->
      <!--        accept=".csv" -->
      <!--        hidden-->
      <!--      />-->
      <!--    </div>-->
      <!--  </div>-->
      <!--</div>-->

      <!-- Staff List Section -->
      <div class="staff-section">
        <div class="section-header">
          <h3>Staff Members</h3>
          <p class="staff-count">{{ stafflist.length }} staff members</p>
        </div>

        <!-- Empty State -->
        <div v-if="stafflist.length === 0" class="empty-state">
          <div class="empty-icon">
            <i class="bi bi-people"></i>
          </div>
          <h3>No Staff Members</h3>
          <p>Add staff members to get started</p>
        </div>

        <!-- Staff List -->
        <div v-else class="staff-list">
          <div 
            v-for="(item, i) in stafflist" 
            :key="i" 
            class="staff-card"
          >
            <div class="staff-card-content">
              
              
              <div class="staff-info">
                <div class="staff-header">
                    
                  <h4>{{ item.name }}</h4>
                  <span :class="['staff-badge', item.logintype == 1 ? 'badge-admin' : 'badge-staff']">
                    {{ item.role}}
                  </span>
                </div>
                
                <div class="staff-details">
                    <div class="row">
                      <div class="col-8">
                         <label class="text-muted text-sm">Contact</label>
                      </div>
                      <div class="col-4">
                         <label class="text-muted text-sm">Status</label>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-8">
                         <span>{{ item.mobile || 'Not provided' }}</span>
                      </div>
                      <div class="col-4">
                         <span :class="['status-indicator', item.status == 1 ? 'active' : 'inactive']">
                    {{ item.status == 1 ? 'Active' : 'Inactive' }}
                  </span>
                         
                      </div>
                    </div>
                    
                 
                </div>
               
              </div>
            </div>
            
            <div class="staff-actions">
              <button class="btn-action edit" @click="editStaff(item)">
                <i class="bi bi-pencil"></i>
              </button>
              <button class="btn-action delete" @click="deleteaddstaff(item.id)">
                <i class="bi bi-trash"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </main>

    <!-- Add/Edit Staff Offcanvas -->
    <div class="offcanvas offcanvas-end border-0" tabindex="-1" id="branch" aria-labelledby="branchLabel">
      <div class="offcanvas-header">
        <div class="offcanvas-back" data-bs-dismiss="offcanvas">
          <i class="bi bi-arrow-left"></i>
        </div>
        <h5 class="offcanvas-title" id="branchLabel">
          {{ addstaff.id ? 'Edit Staff' : 'Add New Staff' }}
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
      </div>
      
      <div class="offcanvas-body">
        <form @submit.prevent="AddStaff">
          <div class="form-group">
            <label for="name">{{ language?.staff_name || 'Staff Name' }} *</label>
            <input 
              type="text" 
              id="name" 
              v-model="addstaff.name" 
              class="form-control" 
              required 
              placeholder="Enter staff name"
            >
          </div>
          
          <div class="form-group">
            <label for="contact">{{ language?.contact || 'Contact Number' }}</label>
            <input 
              type="tel" 
              id="contact" 
              v-model="addstaff.mobile" 
              class="form-control" 
              placeholder="Enter contact number"
            >
          </div>
          
          <!--<div class="form-group">-->
          <!--  <label for="username">{{ language?.username || 'Username' }} *</label>-->
          <!--  <input -->
          <!--    type="text" -->
          <!--    id="username" -->
          <!--    v-model="addstaff.username" -->
          <!--    class="form-control" -->
          <!--    required -->
          <!--    placeholder="Enter username"-->
          <!--  >-->
          <!--</div>-->
          
          <!--<div class="form-group">-->
          <!--  <label for="password">{{ language?.password || 'Password' }} *</label>-->
          <!--  <input -->
          <!--    type="password" -->
          <!--    id="password" -->
          <!--    v-model="addstaff.password" -->
          <!--    class="form-control" -->
          <!--    required -->
          <!--    placeholder="Enter password"-->
          <!--  >-->
          <!--</div>-->
          
          <div class="form-group">
            <label for="role">Role *</label>
            <select id="role" v-model="addstaff.role" class="form-select" required>
              <option value="" disabled selected>Select role</option>
              <option value="Admin">Admin</option>
              <option value="Staff">Staff</option>
            </select>
          </div>
          
          <div class="form-group">
            <label for="status">{{ language?.status || 'Status' }}</label>
            <select id="status" v-model="addstaff.status" class="form-select">
              <option value="1">Active</option>
              <option value="0">Inactive</option>
            </select>
          </div>
          
          <div class="form-actions">
            <button type="submit" class="btn btn-primary">
              {{ addstaff.id ? 'Update' : 'Save' }}
            </button>
            <button type="button" class="btn btn-secondary" data-bs-dismiss="offcanvas">
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script> 
import axios from "@/plugins/axios";  

export default {
  name: 'Branch',
  mounted() { 
    this.getBranches();
  },
  data() {
    return { 
      loading: false,
      error: null,
      isUserLogged: false,
      user_details: [],
      language: this.getLocalStorageArray('lang'),
      addstaff: {
        name: '',
        status: 1,
        contact: '',
        username: '',
        password: '',
        logintype: ''
      },
      stafflist: [], 
      branch_name: '',
    }
  },
  methods: {
    add_new_staff() {
     this.addstaff= {
        name: '',
        status: 1,
        contact: '',
        username: '',
        password: '',
        logintype: ''
      };
    },
    
    goBack() {
      this.$router.go(-1);
    },
    
    goprevious() {
      this.$router.push("/branch");
    },

    async getBranches() {
      this.loading = true;
      this.error = null;
  
      try {
        var self = this;
        axios.post("getaddstaff").then((response) => {
          self.stafflist = response.data.stafflist;
          self.language = response.data.language;
          localStorage.setItem('lang', response.data.language);
        }).then(() => {
          self.initializeHomeContent();
        }).catch((err) => {
          console.error(err);
        });
      } catch (err) {
        this.error = err.response?.data?.message || "Request failed. Please try again.";
      } finally {
        this.loading = false;
      }
    }, 

    AddStaff() {
      this.loading = true;
      this.error = null;

      try {
        var self = this;
        if (self.addstaff.name == '') {
          self.$swal.fire("Name is Required!");
        } else {
          axios.post("addstaff", self.addstaff).then((response) => {
            self.stafflist = response.data.stafflist;
            self.language = response.data.language;
            self.$swal.fire(response.data.message);
            
            if (response.data.success) {
              // Reset form
              self.addstaff = {
                name: '',
                status: 1,
                contact: '',
                username: '',
                password: '',
                logintype: ''
              };
              window.bootstrap.Offcanvas.getOrCreateInstance(document.getElementById("branch")).hide();
            }
          }).then(() => {
            self.initializeHomeContent();
          }).catch((err) => {
            console.error(err);
          });
        }
      } catch (err) {
        this.error = err.response?.data?.message || "Request failed. Please try again.";
      } finally {
        this.loading = false;
      }
    }, 

    editStaff(staff) {
      this.addstaff = {...staff};
      window.bootstrap.Offcanvas.getOrCreateInstance(document.getElementById("branch")).show();
    }, 

    deleteaddstaff(id = "") {
      this.loading = true;
      this.error = null;

      try {
        var self = this;
        this.$swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          confirmButtonText: "Yes, delete it!",
          cancelButtonText: "Cancel",
        }).then((result) => {
          if (result.isConfirmed) {
            axios.post("deleteaddstaff", { id: id }).then((response) => {
              self.stafflist = response.data.stafflist;
              self.$swal.fire(response.data.message);
            }).then(() => {
               
            }).catch((err) => {
              self.$swal.fire("Error!", "Something went wrong.", "error");
            });
          }
        });
      } catch (err) {
        this.error = err.response?.data?.message || "Request failed. Please try again.";
      } finally {
        this.loading = false;
      }
    },

    getLocalStorageArray(key) {
      let data = localStorage?.getItem(key);
      try {
        return data ? JSON.parse(data) : [];
      } catch (e) {
        console.error("Error parsing localStorage data", e);
        return [];
      }
    },

    async handleFileUpload(e) {
      var self = this;
      const file = e.target.files[0];
      if (!file) return;
      
      const formData = new FormData();
      formData.append("csv_file", file);

      try {
        const response = await axios.post("importcsvstaff", formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        self.stafflist = response.data.stafflist || self.stafflist;
        self.$swal.fire({
          icon: 'success',
          title: 'Success',
          text: response.data.msg || 'CSV imported successfully'
        });
        this.getBranches(); // Refresh the list
      } catch (error) {
        console.error("Upload Failed:", error);
        self.$swal.fire({
          icon: 'error',
          title: 'Upload Failed',
          text: error.response?.data?.msg || 'Failed to import CSV'
        });
      }
    }
  }
}
</script>

<style scoped>
.app-container {
  min-height: 100vh;
  background: #f5f7fa;
}

.spinner-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.spinner {
  width: 50px;
  height: 50px;
  border: 5px solid #f3f3f3;
  border-top: 5px solid #0056c2;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.app-header {
  background: linear-gradient(135deg, #0056c2 0%, #003a75 100%);
  color: white;
  padding: 16px;
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.back-button {
  font-size: 20px;
  cursor: pointer;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background 0.3s;
}

.back-button:active {
  background: rgba(255, 255, 255, 0.2);
}

.header-title h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
}

.btn-add {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  transition: all 0.3s;
}

.btn-add:active {
  background: rgba(255, 255, 255, 0.3);
  transform: scale(0.95);
}

.main-content {
  padding: 20px 16px;
  padding-bottom: 80px;
}

.section-header {
  margin-bottom: 16px;
}

.section-header h3 {
  margin: 0 0 8px;
  font-size: 18px;
  color: #2c3e50;
  font-weight: 600;
}

.staff-count {
  margin: 0;
  font-size: 14px;
  color: #7f8c8d;
}

.csv-section {
  margin-bottom: 24px;
}

.csv-card {
  background: white;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.csv-content {
  display: flex;
  align-items: center;
  gap: 16px;
}

.csv-icon {
  width: 50px;
  height: 50px;
  background: rgba(76, 175, 80, 0.1);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #4caf50;
}

.csv-info h4 {
  margin: 0 0 4px;
  font-size: 16px;
  color: #2c3e50;
}

.csv-info p {
  margin: 0;
  font-size: 14px;
  color: #7f8c8d;
}

.btn-csv {
  background: #4caf50;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 10px 16px;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  transition: all 0.3s;
}

.btn-csv:active {
  background: #388e3c;
  transform: scale(0.98);
}

.staff-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.staff-card {
  background: white;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.staff-card-content {
  display: flex;
  align-items: center;
  padding: 16px;
  gap: 16px;
}

.staff-avatar {
  width: 50px;
  height: 50px;
  background: rgba(0, 86, 194, 0.1);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #0056c2;
  flex-shrink: 0;
}

.staff-info {
  flex: 1;
}

.staff-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.staff-header h4 {
  margin: 0;
  font-size: 16px;
  color: #2c3e50;
  font-weight: 600;
}

.staff-badge {
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
}

.badge-admin {
  background: rgba(156, 39, 176, 0.1);
  color: #9c27b0;
}

.badge-staff {
  background: rgba(33, 150, 243, 0.1);
  color: #2196f3;
}

.staff-details p {
  margin: 4px 0;
  font-size: 14px;
  color: #7f8c8d;
  display: flex;
  align-items: center;
  gap: 8px;
}

.staff-status {
  margin-top: 8px;
}

.status-indicator {
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
}

.status-indicator.active {
  background: rgba(76, 175, 80, 0.1);
  color: #4caf50;
}

.status-indicator.inactive {
  background: rgba(244, 67, 54, 0.1);
  color: #f44336;
}

.staff-actions {
  display: flex;
  padding: 0 16px 16px;
  gap: 8px;
  justify-content: flex-end;
}

.btn-action {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  transition: all 0.3s;
}

.btn-action:active {
  transform: scale(0.95);
}

.btn-action.edit {
  background: rgba(33, 150, 243, 0.1);
  color: #2196f3;
}

.btn-action.delete {
  background: rgba(244, 67, 54, 0.1);
  color: #f44336;
}

.empty-state {
  text-align: center;
  padding: 40px 20px;
  color: #7f8c8d;
}

.empty-icon {
  font-size: 60px;
  margin-bottom: 16px;
  opacity: 0.5;
}

.empty-state h3 {
  margin: 0 0 8px;
  font-size: 18px;
}

.empty-state p {
  margin: 0;
  font-size: 14px;
}

/* Offcanvas Styles */
.offcanvas-header {
  padding: 16px;
  border-bottom: 1px solid #e9ecef;
}

.offcanvas-back {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.3s;
  margin-right: 12px;
}

.offcanvas-back:active {
  background: #f5f7fa;
}

.offcanvas-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #2c3e50;
}

.offcanvas-body {
  padding: 16px;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 600;
  color: #2c3e50;
  font-size: 14px;
}

.form-control, .form-select {
  width: 100%;
  padding: 2px 5px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  font-size: 16px;
  transition: border-color 0.3s;
}

.form-control:focus, .form-select:focus {
  outline: none;
  border-color: #0056c2;
  box-shadow: 0 0 0 3px rgba(0, 86, 194, 0.1);
}

.form-actions {
  display: flex;
  gap: 12px;
  margin-top: 24px;
}

.btn {
  flex: 1;
  padding: 12px 20px;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
}

.btn:active {
  transform: scale(0.98);
}

.btn-primary {
  background: #0056c2;
  color: white;
}

.btn-primary:active {
  background: #003a75;
}

.btn-secondary {
  background: #f5f7fa;
  color: #7f8c8d;
}

.btn-secondary:active {
  background: #e9ecef;
}

@media (max-width: 480px) {
  .csv-card {
    flex-direction: column;
    gap: 16px;
    align-items: flex-start;
  }
  
  .staff-card-content {
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
  }
  
  .staff-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
}
.text-sm{
    font-size: 14px;
}
</style>